import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
    emailError: false,
  },
});

class ManagePhoneNumbersAddDialog extends Component {
  state = {
    phone: "",
    phoneError: false,
  };

  handleCreate = () => {
    const phoneRegex = /^(\+\d{1,2}\d{3}\d{3}\d{4})$/;
    if (this.state.phone != "" && this.state.phone.match(phoneRegex)) {
      let clientPhoneNumber = {
        phone: this.state.phone,
      };
      this.props.onClose(clientPhoneNumber);
      this.setState({ phone: "" });
    } else {
      this.setState({ phoneError: true });
    }
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  render() {
    const { classes, open, onClose } = this.props;
    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        aria-labelledby="create-client-phone-dialog"
      >
        <DialogTitle id="create-client-phone-dialog">
          Add a Phone Number
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            id="create-client-phone"
            label="+1XXXXXXXXXX"
            className={classes.textField}
            onChange={this.handleChange("phone")}
            margin="normal"
            name="client.phone"
            required
            error={this.state.phoneError}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleCreate} color="primary" autoFocus>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ManagePhoneNumbersAddDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export default withStyles(styles)(ManagePhoneNumbersAddDialog);
